<template>
  <footer
    class="absolute bottom-0 w-full py-2 text-white bg-color-primary flex justify-center items-center text-xs md:text-sm lg:text-lg"
  >
    Copyright © 2024
    <a href="https://www.instagram.com/rfd_hlmi08" class="font-bold mx-1">
      Rafid Hilmi</a
    >. All rights reserved.
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
  }
</script>
